/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateGroupContractMandatsCommand
 */
export interface UpdateGroupContractMandatsCommand {
    /**
     * True (CADRE only): each aliment's subscriber pays their own SEPA direct debit
     * → no mandate created at the contract level.
     * False (default): the group contract subscriber pays for all → mandates are created
     * per unique (debtor IBAN, creditor IBAN) pair across active tunnels.
     * 
     * @type {boolean}
     * @memberof UpdateGroupContractMandatsCommand
     */
    paymentByAliments: boolean;
    /**
     * Bank account id (subscriber's). Ignored when paymentByAliments == true.
     * @type {string}
     * @memberof UpdateGroupContractMandatsCommand
     */
    bankAccountId?: string | null;
}

/**
 * Check if a given object implements the UpdateGroupContractMandatsCommand interface.
 */
export function instanceOfUpdateGroupContractMandatsCommand(value: object): value is UpdateGroupContractMandatsCommand {
    if (!('paymentByAliments' in value) || value['paymentByAliments'] === undefined) return false;
    return true;
}

export function UpdateGroupContractMandatsCommandFromJSON(json: any): UpdateGroupContractMandatsCommand {
    return UpdateGroupContractMandatsCommandFromJSONTyped(json, false);
}

export function UpdateGroupContractMandatsCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGroupContractMandatsCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentByAliments': json['paymentByAliments'],
        'bankAccountId': json['bankAccountId'] == null ? undefined : json['bankAccountId'],
    };
}

export function UpdateGroupContractMandatsCommandToJSON(json: any): UpdateGroupContractMandatsCommand {
    return UpdateGroupContractMandatsCommandToJSONTyped(json, false);
}

export function UpdateGroupContractMandatsCommandToJSONTyped(value?: UpdateGroupContractMandatsCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentByAliments': value['paymentByAliments'],
        'bankAccountId': value['bankAccountId'],
    };
}

